import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Shop from '@/components/Shop'
import News from '@/components/News'
import NewsInfo from '@/components/NewsInfo'
import Regist from '@/components/Regist'
import Login from '@/components/Login'
import My from '@/components/My/My'
// import Money from '@/components/Moneys/Money'
// import Search from '@/components/Message/Search'
import Chat from '@/components/Message/Chat'
import Chatroom from '@/components/Message/Chatroom'
import Code from '@/components/Message/Code'
import Newchat from '@/components/Message/Newchat'

import AddGroupChat from '@/components/Group/AddGroupChat'
import GroupChatroom from '@/components/Group/GroupChatroom'
import GroupChatSet from '@/components/Group/GroupChatSet'
import GroupMemberList from '@/components/Group/GroupMemberList'
import GroupNameUpdate from '@/components/Group/GroupNameUpdate'
import MyGroupNickUpdate from '@/components/Group/MyGroupNickUpdate'
import GroupManage from '@/components/Group/GroupManage'
import AddGroupManage from '@/components/Group/AddGroupManage'
import DelGroupManage from '@/components/Group/DelGroupManage'
import ShowGroupManage from '@/components/Group/ShowGroupManage'
import MoveGroupMember from '@/components/Group/MoveGroupMember'
import InviteNewFriends from '@/components/Group/InviteNewFriends'
import GroupInfo from '@/components/Group/GroupInfo'
import GroupNotice from '@/components/Group/GroupNotice'

import Friend from '@/components/AddressList/Friend'
import NewFriends from '@/components/AddressList/NewFriends'
import SelectionGroup from '@/components/AddressList/SelectionGroup'
import Service from '@/components/AddressList/Service'
import ServiceChatroom from '@/components/AddressList/ServiceChatroom'
import OnlineService from '@/components/AddressList/OnlineService'

import UserInfo from '@/components/User/UserInfo'
import UserInfoSet from '@/components/User/UserInfoSet'
import SetRemarkName from '@/components/User/SetRemarkName'

import MyInfo from '@/components/My/MyInfo'
import UpInfo from '@/components/My/UpInfo'
import Set from '@/components/My/Set'
import Message from '@/components/My/Message'
import Notice from '@/components/My/Notice'
import Password from '@/components/My/Password'
import Setfontsize from '@/components/My/Setfontsize'
import NeighbourMoments from "@/components/My/NeighbourMoments"
import NeighbourEdit from "@/components/My/NeighbourEdit"
import NeighbourNewMsg from "@/components/My/NeighbourNewMsg"
import Scan from '@/components/Scan'
import Sign from '@/components/My/Sign'
import StoreManage from '@/components/My/Store/StoreManage'
import StoreInfo from '@/components/My/Store/StoreInfo'
import StoreGoods from '@/components/My/Store/StoreGoods'
import StoreOrder from '@/components/My/Store/StoreOrder'
import StoreActivity from '@/components/My/Store/StoreActivity'
import Shopping from '@/components/Store/Index'
import Cart from '@/components/Store/Cart'
import Address from "@/components/My/Address"
import Product from '@/components/Store/Product'
import Favorites from "@/components/My/Favorites"
import Order from "@/components/My/Order"
import AuthCall from '@/components/AuthCall'
import Remind from "@/components/My/Remind"
import RemindInfo from "@/components/My/RemindInfo"

import Clans from "@/components/Clans/Main"
import Pedigree from "@/components/Clans/Pedigrees"
import PedigreeChart from "@/components/Clans/PedigreeChart"
import PedigreeSearch from "@/components/Clans/PedigreeSearch"

Vue.use(Router)

export default new Router({
	//mode:'history',
	routes: [
		// 登录
		{
			path: '/Login', name: 'Login', component: Login
		},
		// 注册
		{
			path: '/Regist', name: 'Regist', component: Regist
		},
		// 单聊
		{
			path: '/Chatroom', component: Chatroom, name: 'Chatroom'
		},
		// // 搜索
		// {
		//		path: '/Search', component: Search, name: 'Search'
		// },
		// 发起群聊
		{
			path: '/AddGroupChat', component: AddGroupChat, name: 'AddGroupChat'
		},
		// 新朋友
		{
			path: '/NewFriends', component: NewFriends, name: 'NewFriends'
		},
		// 新朋友选择群
		{
			path: '/SelectionGroup', component: SelectionGroup, name: 'SelectionGroup'
		},
		// 群聊
		{
			path: '/GroupChatroom', component: GroupChatroom, name: 'GroupChatroom'
		},
		// 群聊设置
		{
			path: '/GroupChatSet', component: GroupChatSet, name: 'GroupChatSet'
		},
		// 群成员列表
		{
			path: '/GroupMemberList', component: GroupMemberList, name: 'GroupMemberList'
		},
		// 修改群名称
		{
			path: '/GroupNameUpdate', component: GroupNameUpdate, name: 'GroupNameUpdate'
		},
		// 修改自己在群内昵称
		{
			path: '/MyGroupNickUpdate', component: MyGroupNickUpdate, name: 'MyGroupNickUpdate'
		},
		// 群管理
		{
			path: '/GroupManage', component: GroupManage, name: 'GroupManage'
		},
		//添加群管理
		{
			path: '/AddGroupManage', component: AddGroupManage, name: 'AddGroupManage'
		},
		//删除群管理
		{
			path: '/DelGroupManage', component: DelGroupManage, name: 'DelGroupManage'
		},
		//群公告
		{
			path: '/GroupNotice', component: GroupNotice, name: 'GroupNotice'
		},
		//群管理显示页面
		{
			path: '/ShowGroupManage', component: ShowGroupManage, name: 'ShowGroupManage'
		},
		// 移动群成员选择群
		{
			path: '/MoveGroupMember', component: MoveGroupMember, name: 'MoveGroupMember'
		},
		// 邀请朋友进群
		{
			path: '/InviteNewFriends', component: InviteNewFriends, name: 'InviteNewFriends'
		},
		{
			path: '/Code', component: Code, name: 'Code'
		},
		// 用户所在群组信息
		{
			path: '/GroupInfo', component: GroupInfo, name: 'GroupInfo'
		},
		//  {
		//    path: '/Footer', component: Footer, name: 'Footer'
		//  },
		// 联系客服
		{
			path: '/Service', component: Service, name: 'Service'
		},
		// 客服小蜜
		{
			path: '/ServiceChatroom', component: ServiceChatroom, name: 'ServiceChatroom'
		},
		// 在线客服
		{
			path: '/OnlineService', component: OnlineService, name: 'OnlineService'
		},
		// 朋友个人资料
		{
			path: '/UserInfo', component: UserInfo, name: 'UserInfo'
		},
		// 
		//信息中心
		{
			path: '/Message', component: Message, name: 'Message'
		},
		// 公告
		{
			path: '/Notice', component: Notice, name: 'Notice'
		},
		//设置
		{
			path: '/Set', component: Set, name: 'Set'
		},
		//朋友圈
		{
			path: '/NeighbourMoments', component: NeighbourMoments, name: 'NeighbourMoments'
		},
    //朋友圈编辑区域
        {
          path: '/NeighbourEdit', component: NeighbourEdit, name: 'NeighbourEdit'
        },
      //朋友圈新消息列表区域
        {
          path: '/NeighbourNewMsg', component: NeighbourNewMsg, name: 'NeighbourNewMsg'
        },

		// 朋友个人资料设置
		{
		  path: '/UserInfoSet', component: UserInfoSet, name: 'UserInfoSet'
		},
		// 设置备注名
		{
		  path: '/SetRemarkName', component: SetRemarkName, name: 'SetRemarkName'
		},
		// 个人信息
		{
		  path: '/MyInfo', component: MyInfo, name: 'MyInfo'
		},
		// 修改个人信息
		{
		  path: '/UpInfo', component: UpInfo, name: 'UpInfo'
		},
		{
		  path: '/Password', component: Password, name: 'Password'
		},
		{
		  path: '/Newchat', component: Newchat, name: 'Newchat'
		},
		 {
		   path: '/Setfontsize', component: Setfontsize, name: 'Setfontsize'
		 },
		// {
		//   path: '/InvtCode', component: InvtCode, name: 'InvtCode'
		// },
		{
			path: '/',
			name: 'Index',
			component: Index,
			children: [
				{
					path: '/', component: News, name: 'News'
				},
				{
					path: '/News', component: News, name: 'News'
				},
				{
					path: '/Shop', component: Shop, name: 'Shop'
				},
				{
					path: '/Chat', component: Chat, name: 'Chat'
				},
				{
					path: '/Friend', component: Friend, name: 'Friend'
				},
			// {
			//   path: '/Money', component: Money, name: 'Money'
			// },
				{
					path: '/My', component: My, name: 'My',
				},
				{
					path: '/Clans',
					name: 'Clans',
					component: Clans,
					children: [
						{
							path: '', component: Pedigree, name: 'Pedigree'
						},
						{
							path: '/Clans/Chart/:p_id', component: PedigreeChart, name: 'PedigreeChart'
						},
						{
							path: '/Clans/Search', component: PedigreeSearch, name: 'PedigreeSearch'
						}
					]
				}
			]
		},
		{
			path: '/News/Info/:n_id', component: NewsInfo, name: 'NewsInfo'
		},
		// 扫码
		{
			path: '/Scan', name: 'Scan', component: Scan
		},
		// 签到
		{
			path: '/Sign', name: 'Sign', component: Sign
		},
		// 店铺管理
		{
			path: '/StoreManage', name: 'StoreManage', component: StoreManage
		},
		// 店铺信息编辑
		{
			path: '/StoreInfo', name: 'StoreInfo', component: StoreInfo
		},
		// 店铺产品管理
		{
			path: '/StoreGoods/:s_id', name: 'StoreGoods', component: StoreGoods
		},
		// 店铺订单管理
		{
			path: '/StoreOrder/:s_id', name: 'StoreOrder', component: StoreOrder
		},
		// 店铺
		{
			path: '/Shopping/:s_id', name: 'Shopping', component: Shopping
		},
		// 店铺活动管理
		{
			path: '/StoreActivity/:s_id', name: 'StoreActivity', component: StoreActivity
		},
		// 购物车
		{
			path: '/Cart', name: 'Cart', component: Cart
		},
		//收货地址
		{
			path: '/Address', component: Address, name: 'Address'
		},
		// 商品详情
		{
			path: '/Product/:s_id/:g_id', name: 'Product', component: Product
		},
		//收藏中心
		{
			path: '/Favorites', component: Favorites, name: 'Favorites'
		},
		//订单中心
		{
			path: '/Order', component: Order, name: 'Order'
		},
		//微信载体授权跳转
		{
			path: '/AuthCall', component: AuthCall, name: 'AuthCall'
		},
		//提醒日程
		{
			path: '/Remind', component: Remind, name: 'Remind'
		},
		//提醒日程详情
		{
			path: '/RemindInfo/:id/:code', component: RemindInfo, name: 'RemindInfo'
		}
	]
})




// WEBPACK FOOTER //
// ./src/router/index.js